import React, { createContext, useState } from "react";

const CNDContext = createContext();

const CNDContextProvider = ({ children }) => {
  const [optionsClientes, setOptionsClientes] = useState([]);
  const [loadingInputs, setLoadingInputs] = useState({});

  return (
    <CNDContext.Provider
      value={{
        optionsClientes,
        setOptionsClientes,

        loadingInputs,
        setLoadingInputs,
      }}
    >
      {children}
    </CNDContext.Provider>
  );
};

export { CNDContextProvider, CNDContext };
